import Vue from "vue";
import App from "./App.vue";
import store from "./store";

// import { RunConfigService, ConfigService } from "@nuskin/ns-util";

// RunConfigService.setRunConfig({
//   language: "en",
//   country: "US"
// });
// /** TODO: dynmamic url */
// RunConfigService.setBaseUrl("https://test.nuskin.com");
// ConfigService.getMarketConfig();

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
